<template v-if="isVisible">
    <vl-alert icon="credit-card" title="Hoe een testbetaling uitvoeren?" :closable="false">
        <vl-typography>
            <div>Volgende mogelijkheden om testbetalingen uit te voeren:</div>
            <ol>
                <li>
                    Betalen met kaart (Approved):<br/>
                    <ul>
                        <li>Bancontact: kaartnummer 6060 0599 9998 9902 3</li>
                        <li>VISA: kaartnummer 4330 2649 3634 4675 - CVV 123</li>
                        <li>MASTERCARD: kaartnummer 5137 0098 0194 3438  - CVV 123</li>
                    </ul>
                </li>
                <li>
                    Meer mogelijkheden op: <a
                        href="https://docs.direct.worldline-solutions.com/en/integration/how-to-integrate/test-cases/index"
                        target="_blank" rel="noopener noreferrer">API Test cases</a>
                </li>
            </ol>
        </vl-typography>
    </vl-alert>
    <vl-u-spacer mod-small/>
</template>